import { render, staticRenderFns } from "./ProfileSettingsView.vue?vue&type=template&id=5a4a9c2c"
import script from "./ProfileSettingsView.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports